import { INTERMODAL_TYPES } from '../constants/ShipmentTypes';

export const isIntermodalShipmentType = (shipment) => {
  let type;
  if (typeof shipment === 'string') {
    type = shipment;
  } else {
    type = shipment?.shipment_type;
  }
  return INTERMODAL_TYPES.includes(type);
};

export const isDrayageShipment = (shipment) => {
  let type;
  if (typeof shipment === 'string') {
    type = shipment;
  } else {
    type = shipment?.shipment_type;
  }
  return type === 'drayage';
};

export const isRailShipment = (shipment) => {
  let type;
  if (typeof shipment === 'string') {
    type = shipment;
  } else {
    type = shipment?.shipment_type;
  }

  return type === 'rail';
};

export const isDrayageOrRailShipment = (shipment) =>
  isDrayageShipment(shipment) || isRailShipment(shipment);

export const isImport = (shipment) =>
  shipment.order_type && shipment.order_type === 'import';

export const isExportShipment = (shipment) => shipment?.order_type === 'export';

export const isDomesticDelivery = (shipment) =>
  shipment.order_type &&
  shipment.order_type === 'domestic' &&
  shipment.order_movement_type === 'delivery';
